import { Box, Container, Flex, Heading } from "@chakra-ui/core";
import React from "react";
import AddNewPost from "./add-new-post";

const Navbar = ({ posts, refreshPage }) => {
  return (
    <Box position="sticky" top={0} p={4} bg="gray.100" zIndex={1}>
      <Container maxW="lg" centerContent>
        <Flex justifyContent="flex-end" w="100%" position="sticky" top={0}>
          <Heading flex='auto'> CloudPosts </Heading>
          <AddNewPost posts={posts} refreshPage={refreshPage}/>
        </Flex>
      </Container>
    </Box>
  );
};

export default Navbar;